// Função para obter URL da API baseada no tema atual
const obterAPIBaseURL = () => {
  try {
    const hostname = window.location.hostname;
    const isProducao = process.env.NODE_ENV === 'production';

    if(!isProducao)
      return "http://localhost:8897/";

    if (hostname.includes('clientes-dev'))
      return "https://clientes-api-dev.dixiponto.com.br";

    // Detectar tema pela URL
    if (hostname.includes('evo')) 
      return "https://licenca-api.evosistemasinteligentes.com.br/";

    if (hostname.includes('tecnoponto')) 
      return "https://licenca-api.tecnopontonuvem.com/";
    if (hostname.includes('bra.licenca')) 
      return "https://bra.web.dixiponto.com.br/apis/api-clientes/";

    // Padrão: DIXI (localhost e dixi)
    return "https://licenca-api.dixiponto.com.br/";
  } catch (error) {
    // Fallback em caso de erro
    return process.env.NODE_ENV === 'production' 
      ? "https://licenca-api.dixiponto.com.br/" 
      : "http://localhost:8897/";
  }
};

const API_BASE_URL = obterAPIBaseURL();

export default API_BASE_URL;